import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ACCENT_COLOR } from '@/constants/colors';

interface FieldsetGroupProps {
  legend: string;
  children: React.ReactNode;
}

/**
 * FieldsetGroup — MUI-styled <fieldset> with a legend label.
 *
 * Renders a bordered container with a legend overlapping the top border,
 * matching the original Python app's fieldset styling.
 */
const FieldsetGroup: React.FC<FieldsetGroupProps> = ({ legend, children }) => (
  <Box
    component="fieldset"
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      px: 1.5,
      pt: 0.5,
      pb: 1,
      m: 0,
      '& > legend': {
        px: 0.5,
        fontSize: '0.75rem',
        fontWeight: 600,
        color: ACCENT_COLOR,
      },
    }}
  >
    <Typography component="legend">{legend}</Typography>
    {children}
  </Box>
);

export default React.memo(FieldsetGroup);
